/**
 * Saves metadata about public VisitorAttribute entities.
 *
 * These can be behavioral attributes, DCP attributes, or generic "custom" attributes.
 *
 * For details, see [models/visitor_attribute.py@95ff00a2](https://github.com/optimizely/optimizely/blob/95ff00a244acd7ccfed7a8fdfe9066b8796cc7d0/src/www/models/visitor_attribute.py).
 *
 * @module
 */
var _ = require('optimizely-client-fn');

var actionTypes = require('../constants/action_types');

module.exports = {
  initialize: function () {
    this.__state = {} as any;

    this.on(actionTypes.DATA_LOADED, this.__setVisitorAttributeEntities);
  },

  /**
   * @returns {VisitorAttribute[]}
   */
  getCustomBehavioralAttributes: function(): VisitorAttribute[] {
    return _.filter(this.__state, function(attribute) {
      return !!attribute.rule_json;
    });
  },

  /**
   * @param {VisitorAttributeDescriptor} options
   * @returns {VisitorAttribute}
   */
  getVisitorAttribute: function(options:VisitorAttributeDescriptor): VisitorAttribute {
    if (__INVARIANT__) {
      require('../utils/invariant').isType('VisitorAttributeDescriptor', options);
    }

    var attributes = _.values(this.__state);

    // Filter by DCP data source ID, if supplied.
    // This may help identify a single attribute with the given name.
    if (options.datasourceId) {
      attributes = _.filter(attributes, {
        dcp_datasource_id: String(options.datasourceId)
      });
    }

    if (options.attributeName && options.attributeId) {
      throw new Error('Must not specify both attribute name and attribute ID');
    }
    else if (options.attributeId) {
      var attributeWithId = this.__state[options.attributeId];
      if (!attributeWithId) {
        throw new Error('Unrecognized attribute ID: ' + options.attributeId);
      }
      return attributeWithId;
    }
    else if (options.attributeName) {
      var attributesWithName = _.filter(attributes, {
        name: options.attributeName
      });
      if (!attributesWithName.length) {
        throw new Error('Unrecognized attribute name: ' + options.attributeName);
      }
      if (attributesWithName.length > 1) {
        throw new Error('Too many attributes with name: ' + options.attributeName);
      }
      return attributesWithName[0];
    }
    else {
      throw new Error('Must specify attribute name or attribute ID');
    }
  },

  /**
   * Saves metadata about public VisitorAttribute entities based on the DATA object being loaded.
   * @param {Object} payload
   * @param {ClientData} payload.data
   * @private
   */
  __setVisitorAttributeEntities: function (payload:any) {
    if (_.isEmpty(payload.data.visitorAttributes)) {
      return;
    }
    _.each(payload.data.visitorAttributes, _.bind(function(attribute) {
      this.__state[attribute.id] = attribute;
    }, this));
    this.emitChange();
  },
};
